<template>
    <div class="groupCart">
        <Header ref="header" :title="title" @backPage="onBack" ></Header>
        <div class="container" v-show="isShow">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <h3>主活动商品</h3>
            <GoodsTemplate
                v-for="(item, index) in goodList"
                :key="index + '01'"
                :goodData='item'
                @editCheck='editCheck(item, 1)'
                @handleDetail='handleDetail(item)'
                type='home'
            />
            <div class="hr" />
            <h3>自由搭配区</h3>
            <GoodsTemplate
                v-for="(item, index) in sapList"
                :key="index + '02'"
                :goodData='item'
                @editCheck='editCheck(item)'
                @handleButton='complatedMoney'
                @handleDetail='handleDetail(item)'
            />
            </van-pull-refresh>
            <FootTemplate
                v-if="showStatic"
                :totalNum='checkedData.length + checkedData2.length'
                :totoalMoney='totoalMoney'
                @handleSubmit='handleSubmit'
            />
        </div>
    </div>
</template>

<script>
import Header from '../../common/header'
import GoodsTemplate from './component/goodsTemplate'
import FootTemplate from './component/footTemplate'
import { clearCache, newCache } from '@/utils/index'
import { getGroupGoodList } from '../api/activity'
import { getSubmitOrder } from '../api/order'
import { Toast } from 'vant'
export default {
    name: 'groupActivityCart',
    components: {
        Header,
        GoodsTemplate,
        FootTemplate
    },
    data () {
        return {
            title: '选择您的组合',
            userInfo: {},
            checkedData: [], // 选中的主商品
            checkedData2: [], // 选中的辅材商品
            totoalMoney: 0, // 总金额
            isShow: false, // 加载完毕
            isLoading: false,
            showStatic: true, // 底部是否显示
            documentHeight: document.documentElement.clientHeight,
            goodList: [],
            sapList: []
        }
    },
    methods: {
        onBack () {
            this.$router.back()
        },
        // 下拉刷新
        onRefresh () {
            setTimeout(() => {
                this.init()
                this.isLoading = false
            }, 1000)
        },
        // 辅材是否选中
        editCheck (item, type) {
            // 主商品清除选中项
            if (type === 1) {
                this.goodList.filter(item => {
                    item.checked = false
                })
            }
            item.checked = !item.checked
            this.countTotal()
        },
        // 筛选选中的商品
        countTotal () {
            let number = this.goodList.filter(item => {
                return item.checked
            })
            let number2 = this.sapList.filter(item => {
                return item.checked
            })
            this.checkedData = number
            this.checkedData2 = number2
            this.complatedMoney()
        },
        // 主商品和辅材商品的价格合计
        complatedMoney () {
            if (!(this.checkedData.length && this.checkedData2.length)) {
                this.totoalMoney = 0
                return false
            }
            let total = this.checkedData.reduce((sumFor, item) => {
                return parseFloat(sumFor) + parseFloat(item.discountPrice) * parseInt(item.quantity)
            }, 0)
            let total2 = this.checkedData2.reduce((sumFor, item) => {
                return parseFloat(sumFor) + parseFloat(item.discountPrice) * parseInt(item.quantity)
            }, 0)
            this.totoalMoney = total + total2
        },
        handleDetail (item) {
            if (!item.spuId) {
                return
            }
            localStorage.removeItem('goodsDetailBack')
            this.$router.push({ path: '/b2b/goods/goodsDetail', query: { id: item.spuId } })
        },
        async handleSubmit () {
            if (!this.$isApproveShow()) {
                this.$refs.popApp.onShow()
                return false
            }
            if (!this.checkedData.length) {
                Toast('请至少选择一个主活动商品')
                return false
            }
            if (!this.checkedData2.length) {
                Toast('请至少选择一个自由搭配商品')
                return false
            }
            let checkedListData = [...this.checkedData, ...this.checkedData2]
            let subData = checkedListData.map(item => {
                return {
                    quantity: item.quantity,
                    skuId: item.skuId
                }
            })
            let shopArr = [{
                merchantCode: this.userInfo.belongMerchantCode,
                tyingId: this.$route.query.tyingId,
                skus: subData
            }]
            await getSubmitOrder({
                merchantCode: this.userInfo.belongMerchantCode,
                memberCode: this.userInfo.companyCode,
                shops: shopArr
            })
            localStorage.setItem('goodsData', JSON.stringify(shopArr))
            localStorage.removeItem('confirmOrderBack')
            localStorage.removeItem('themeActivityId')
            this.$router.push({ path: '/b2b/order/confirmOrder', query: { tyingId: this.$route.query.tyingId } })
        },
        async init () {
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            const { data } = await getGroupGoodList({
                tyingId: this.$route.query.tyingId,
                memberCode: this.userInfo.companyCode
            })
            let mainMaterialList = data.mainMaterialList
            let auxiliaryMaterialList = data.auxiliaryMaterialList
            mainMaterialList.filter(item => {
                item.checked = (mainMaterialList.length === 1) && item.remainingStock
                item.orderMinCount = 1
                item.inventory = (item.remainingStock > item.purchaseLimit) ? item.purchaseLimit : item.remainingStock
                item.disabled = mainMaterialList.length === 1
                item.quantity = item.orderMinCount
            })
            auxiliaryMaterialList.filter(item => {
                item.checked = false
                item.inventory = (item.remainingStock > item.purchaseLimit) ? item.purchaseLimit : item.remainingStock
                item.quantity = item.orderMinCount
            })
            this.goodList = mainMaterialList
            this.sapList = auxiliaryMaterialList
            Toast.clear()
            this.isShow = true
            this.countTotal()
        }
    },
    beforeRouteEnter (to, from, next) {
        newCache('groupActivityCart')
        next()
    },
    beforeRouteLeave (to, from, next) {
        if ((to.name !== 'confirmOrder') && (to.name !== 'goodsDetail')) {
            clearCache('groupActivityCart')
        }
        next()
    },
    created () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.init()
    },
    mounted () {
        window.onresize = () => { // 监听窗口的变化，把输入顶到可视区域
            if (/Android/gi.test(navigator.userAgent)) {
                if (this.documentHeight > document.documentElement.clientHeight) {
                    this.showStatic = false
                } else {
                    this.showStatic = true
                }
                window.addEventListener('resize', function () {
                    if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
                        window.setTimeout(function () {
                            document.activeElement.scrollIntoViewIfNeeded()
                        }, 10)
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.groupCart{
    height: auto;
    background: #ffffff;
    .hr{
        border-bottom: 2px solid #EEEEEE;
    }
    .container{
        padding: 0 32px 140px;
        h3{
            padding: 36px 0 24px;
            font-size: 28px;
            color: #666666;
        }
    }
    .col999{
        color: #999999;
    }
    .colFF7A45 {
        color: #FF7A45;
    }
}
/deep/ .van-pull-refresh{
    overflow: initial;
}
</style>
